import { IconButton } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import { instituteInfo } from "../../constant";
import { Box } from "@mui/material";

function ExternalLinks() {
  return (
    <Box data-testid="external-links">
      {/* Gmail Link */}
      <IconButton
        component="a"
        href={`mailto:${instituteInfo.gmail}`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: "#D44638" }}
      >
        <EmailIcon sx={{ fontSize: 40 }} />
      </IconButton>

      {/* Telegram Link */}
      <IconButton
        component="a"
        href={instituteInfo.telegramLink}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: "#0088cc" }}
      >
        <TelegramIcon sx={{ fontSize: 40 }} />
      </IconButton>

      {/* WhatsApp Link */}
      <IconButton
        component="a"
        href={instituteInfo.whatstappLink}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: "#25D366" }}
      >
        <WhatsAppIcon sx={{ fontSize: 40 }} />
      </IconButton>
    </Box>
  );
}

export default ExternalLinks;
